// extracted by mini-css-extract-plugin
export default {"subtitle":"Subtitle_subtitle__96t7b"};